import { render, staticRenderFns } from "./AddAnnouncementModal.vue?vue&type=template&id=4266bdf8"
import script from "./AddAnnouncementModal.vue?vue&type=script&lang=js"
export * from "./AddAnnouncementModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports